// extracted by mini-css-extract-plugin
export const inputEmail = "c_n";
export const btn = "c_p";
export const errorMsg = "c_m";
export const txtBack = "c_q";